import { FC, memo } from 'react'
import { EVariationTypes } from 'core/common/constants/multivariation'
import { PRODUCT_STUBSTEP_KEYS } from 'core/common/constants/product-new'
import i18n from 'core/common/i18n'
import { useStepsProductNew } from 'core/common/store/useStepsProductNew'
import { VariationType } from 'core/components/Multivariation'
import { useMultivariationValues } from '../store'
import { FlowCardProps } from '../types'
import { formatClearValues } from './utils'

const NEXT_VARIATION_STEPS = [
  PRODUCT_STUBSTEP_KEYS.SECOND_VARIATION_VALUE,
  PRODUCT_STUBSTEP_KEYS.THIRD_VARIATION_TYPE,
  PRODUCT_STUBSTEP_KEYS.THIRD_VARIATION_VALUE,
]

const SecondVariationType: FC<FlowCardProps> = ({ onNext, custom }) => {
  const { setVariationType, getType, getValues, setValues } = useMultivariationValues()
  const { setHiddenStep, setVisibleStep } = useStepsProductNew()
  const firstType = getType('first') as EVariationTypes
  const currentType = getType('second')
  const storeValues = getValues()

  const clearValues = () => {
    const newValues = formatClearValues(storeValues)

    setValues(newValues)
  }

  const handleSubmit = (value: EVariationTypes) => {
    setVariationType('second', value)
    setVisibleStep(NEXT_VARIATION_STEPS)

    if (!!currentType && value !== currentType) {
      clearValues()
    }

    onNext()
  }

  const handleSkip = () => {
    setVariationType('second', null)
    setVariationType('third', null)
    setHiddenStep(NEXT_VARIATION_STEPS)
    clearValues()
    onNext()
  }

  return custom?.variation ? (
    custom.variation({
      onSubmit: handleSubmit,
      disabledItems: [firstType],
      title: i18n.t('multivariation.variationType.secondVariationTitle'),
      onSkip: handleSkip,
      variationTypeSelected: currentType,
    })
  ) : (
    <VariationType
      onSubmit={handleSubmit}
      disabledItems={[firstType]}
      title={i18n.t('multivariation.variationType.secondVariationTitle')}
      onSkip={handleSkip}
      variationTypeSelected={currentType}
    />
  )
}

export default memo(SecondVariationType)
